import { IDeviceInitialState } from "./types";

export const initialState: IDeviceInitialState = {
  selectedDeviceAlarms: [],
  selectedDeviceAlarmCount: 0,
  noOfSelectedRow: { deviceRowIds: [], rnRowIds: [], lteCellRowIds: [], nrCellRowIds : [], rfFeedsRowIds : [] },
  isOpenDeviceDrawer: true,
  labelList: [],
  selectedLabel: { text: "", value: "" },
  deviceDataCount: {
    id: 1,
    sn_Count: 0,
    rffeed_Count: 0,
    lte_Zone_Count: 0,
    ng_Zone_Count: 0,
    rn620_Count: 0,
    rn_Up: 0,
    rn_Down: 0,
    lte_Up: 0,
    lte_Down: 0,
    umts_Up: 0,
    umts_Down: 0,
    lan_Up: 0,
    lan_Down: 0,
    ru_Enabled: 0,
    ru_Disabled: 0,
    nr_Enabled: 0,
    nr_Disabled: 0,
    lte_X2_Connected: 0,
    lte_X2_Disconnected: 0,
    ng_X2_Connected: 0,
    ng_X2_Disconnected: 0,
    uptime: "",
    du_Up: 0,
    du_Down: 0,
  },
  drawerCounts: {
    id: 0,
    rn_Up: 0,
    rn_Down: 0,
    lte_Up: 0,
    lte_Down: 0,
    lte_X2_Connected: 0,
    lte_X2_Disconnected: 0,
    ng_X2_Connected: 0,
    ng_X2_Disconnected: 0,
    nr_Enabled: 0,
    nr_Disabled: 0,
    du_Up: 0,
    du_Down: 0,
    uptime: "",
  },
  deviceAction: {
    name: "",
    isTask: false,
  },
  selectedTemplate: {
    id: null,
    domainKey: "",
    imageConstraints: "",
    nodeTypeKey: "",
    templateName: "",
    deviceKey: ""
  },
  selectedType: "none",
  globalTemplate: {
    id: null,
    domainKey: "",
    imageConstraints: "",
    nodeTypeKey: "",
    templateName: "",
    deviceKey: ""
  },
  selectedRnCellConfig: {
    rnCellData: {
      operators: [],
      radios: 0,
      type: "",
      bandCombinationSupported: [],
      radioBandOne: null,
      radioBandTwo: null,
    },
    bandData: [],
  },
  selectedRadioNode: {
    id: 0,
    name: "",
    description: "",
    status: "",
    enable: false,
    ethernetId: "",
    ipAddress: "",
    model: "",
    nodeType: "",
    outerIpAddress: "",
    location: "",
    latitude: "",
    longitude: "",
    radios: [],
  },
  radioFirstLteCellconfig: {
    index: 0,
    enable: "",
    name: "",
    description: "",
    operState: "",
    confState: "",
    radio: 0,
    radioNode: "",
    lteCellConfig: {
      index: "",
      lte: {
        index: "",
        lteRan: {
          index: "",
          lteRanCommon: {
            index: "",
            eci: "",
            cellId: "",
          },
          lteRanRf: {
            index: 0,
            earfcndl: 0,
            dlBandwidth: 0,
            referenceSignalPowerInUse: 0,
            modeInUse: "",
            phyCellIDInUse: 0,
          },
        },
      },
      unlicensedLte: {
        index: "",
        unlicensedLteRan: {
          index: "",
          unlicensedLteRanRf: {
            index: "",
            earfcndls: [],
          },
        },
      },
    },
  },
  radioSecondLteCellconfig: {
    index: 0,
    enable: "",
    name: "",
    description: "",
    operState: "",
    confState: "",
    radio: 0,
    radioNode: "",
    lteCellConfig: {
      index: "",
      lte: {
        index: "",
        lteRan: {
          index: "",
          lteRanCommon: {
            index: "",
            eci: "",
            cellId: "",
          },
          lteRanRf: {
            index: 0,
            earfcndl: 0,
            dlBandwidth: 0,
            referenceSignalPowerInUse: 0,
            modeInUse: "",
            phyCellIDInUse: 0,
          },
        },
      },
      unlicensedLte: {
        index: "",
        unlicensedLteRan: {
          index: "",
          unlicensedLteRanRf: {
            index: "",
            earfcndls: [],
          },
        },
      },
    },
  },
  isOpenRnDrawer: false,
  isCellSaved: false,
  selectedDuNode: {
    id: 0,
    name: "",
    description: "",
    status: "",
    enable: false,
    ethernetId: "",
    ipAddress: "",
    model: "",
    nodeType: "",
    outerIpAddress: "",
    radios: [],
    radioUnit: null,
  },
  radioFirstNrCellconfig: {
    index: "",
    enable: "",
    name: "",
    description: "",
    operState: "",
    confState: "",
    radio: "",
    radioNode: "",
    nrcellConfig: {
      index: "",
      ng: {
        index: "",
        ngran: {
          index: "",
          ngranCommon: {
            index: "",
            eci: null,
            cellId: "",
          },
          ngranRf: {
            index: "",
            earfcndl: "",
            dlBandwidth: "",
            referenceSignalPowerInUse: "",
            modeInUse: "",
            phyCellIDInUse: "",
          },
        },
      },
    },
  },
  radioSecondNrCellconfig: {
    index: "",
    enable: "",
    name: "",
    description: "",
    operState: "",
    confState: "",
    radio: "",
    radioNode: "",
    nrcellConfig: {
      index: "",
      ng: {
        index: "",
        ngran: {
          index: "",
          ngranCommon: {
            index: "",
            eci: null,
            cellId: "",
          },
          ngranRf: {
            index: "",
            earfcndl: "",
            dlBandwidth: "",
            referenceSignalPowerInUse: "",
            modeInUse: "",
            phyCellIDInUse: "",
          },
        },
      },
    },
  },
  isOpenCellDrawer: false,
  isOpenLteDrawer: false,
  isOpenNrDrawer: false,
  isOpenDuDrawer: false,
  isOpenRnCuDrawer: false,
  selectedDevice: {
    altitude: 0,
    serialNumber: "",
    type: 0,
    overrideLocation: false,
    focusPolling: false,
    username: "",
    manufacturerOUI: "",
    longitude: 0,
    snmpVersion: 0,
    writeCommunity: "",
    parentDeviceKey: "",
    unmanaged: false,
    rangeId: 0,
    manufacturer: "",
    latitude: 0,
    locked: false,
    swVersion: "",
    port: 0,
    locationId: "",
    customerId: "",
    hwVersion: "",
    name: "",
    contextName: "",
    majorAlarmCount: 0,
    criticalAlarmCount: 0,
    ipAddress: "",
    readCommunity: "",
    connectionRequestUrl: "",
    groupKey: "",
    sysObjectId: "",
    retry: 0,
    clusterId: "",
    collectPerformance: false,
    collectCellPerformance: false,
    collectLteSystemPerformance: false,
    collectLteCellPerformance: false,
    collectNRSystemPerformance: false,
    collectNRCellPerformance: false,
    collectEquipmentPerformance: false,
    collectCustomPerformance: false,
    maintenanceMode: false,
    managementServerURL: "",
    timeout: 0,
    configurationStatus: "",
    lastInform: 0,
    lastOpStateSync: 0,
    supportTransactions: false,
    supportDBClone: false,
    dmDisplayType: "",
    snConnected: false,
    useDefaultSampleSets: false,
    movedByUser: false,
    pkgCopyStatus: "",
    pkgApplyStatus: "",
    bulkApplyStatus: "",
    modelName: "",
    nodeType: "",
    status: 0,
    operationMode: "",
    pciLockEnable: "",
    contact: "",
    remScanActive: false,
    sysUpTime: 0,
    location: "",
    rcpMode: "",
    duMode: "",
    siteGroupId: "",
    siteGroupName: "",
    ngMaxUESession: "",
    ngCurrentUESession: "",
    lteMaxUESession: "",
    lteCurrentUESession: "",
    pmCollected: false,
    lastPmPollingTime: 0,
    ltePmEnable: false,
    ltePmSampleInterval: 0,
    ngPmEnable: false,
    ngPmSampleInterval: 0,
    authProtocol: '',
    authPassword: '',
    privacyProtocol: '',
    privacyPassword: '',
    geoRegionName: ''
  },
  initialSiteDetails: {
    group: "",
    siteType: "",
    siteName: "",
    serialNumber: "",
    siteLabel: "",
    description: "",
    version: "",
    modelNumber: "",
    state: "",
    latitude: "",
    longitude: "",
    ipAddress: "",
    snmpVersion: "1",
    snmpPort: 161,
    timeout: 5,
    writeCommunity: "",
    readCommunity: "",
    username: "",
    contextName: "",
    authProtocol: "",
    authPassword: "",
    privacyProtocol: "",
    privacyPassword: "",
    urlAddress: "",
  },
  selectedDeviceId: "",
  selectedGeoRegions: [],
};
